import { Route, Routes } from 'react-router-dom';
import FoldersList from './FoldersList';
import FoldersDetails from './FoldersDetails';

const Folders = () => {
  return (
    <Routes>
      <Route path="/" element={<FoldersList />} />
      <Route path="/:folderId" element={<FoldersDetails />} />
    </Routes>
  );
};

export default Folders;
